<template>
  <div style='width: 48%'>
    <!-- 条件模式 -->
    <div style='width:100%;margin-left: 5px;margin-top: 5px;overflow-y: auto;margin-right:5px;'
         v-show="mode === 'condition'">
      <div style='color:white;height:30px;line-height: 30px;' class='w-100 uk-text-center bg-theme cursor-pointer'
           v-if='detailInfo' @click="mode = 'detail'">
        {{ $t('integration.see') }}{{ `${$timetransition(detailInfo.time)} >>` }}
      </div>
      <div style='background:lightgray;color:white;height:30px;line-height: 30px;' class='w-100 uk-text-center'
           v-else>{{ $t('integration.please_select_a_track_point') }}
      </div>
      <div>
        <el-form :model='traceSearchForm' ref='date' class='uk-margin-top uk-margin-small-right' label-width='100px'
                 :rules='rules' label-position='left'>
          <el-form-item prop='from'>
            <template #label>
              <span style='margin-left:15px'>{{ $t('public.start_time') }}</span>
            </template>
            <el-date-picker type='datetime' v-model='traceSearchForm.from' :placeholder="$t('public.select_time')"
                            style='width: 100%'></el-date-picker>
          </el-form-item>
          <el-form-item prop='to'>
            <template #label>
              <span style='margin-left:15px'>{{ $t('public.end_time') }}</span>
            </template>
            <el-date-picker type='datetime' v-model='traceSearchForm.to' :placeholder="$t('public.select_time')"
                            style='width: 100%'></el-date-picker>
          </el-form-item>

          <el-form-item>
            <template #label>
              <span style='margin-left:15px'>{{ $t('public.Filter_conditions') }}</span>
            </template>
            <el-select v-model='traceSearchForm.option' :placeholder="$t('public.please')" style='width: 100%'>
              <el-option v-for='(item, index) in filterOptionList' :key='index'
                 :label="getLanguage() === 'zh_CN' ?item.name:item.content"
                         :value='item.content'></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <el-form :model='speed' :rules='rules' ref='speed' :show-message='false'
                 v-if="traceSearchForm.option === 'filter_speed'" label-width='100px' label-position='left'>
          <!-- 区间下拉选择 -->
          <el-form-item>
            <el-select v-model='condition'>
              <el-option :label="$t('home.range')" :value="'range'"></el-option>
              <el-option :label="$t('home.greater')" :value="'greater'"></el-option>
              <el-option :label="$t('home.less')" :value="'less'"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <div class='uk-flex uk-flex-middle  filter-speed'>
              <!-- 区间 -->
              <template v-if="condition === 'range'">
                <el-form-item prop='less'>
                  <el-input v-model='speed.less'></el-input>
                </el-form-item>
                <el-form-item>
                  <div class='to'>To</div>
                </el-form-item>
                <el-form-item prop='greater'>
                  <el-input v-model='speed.greater'></el-input>
                </el-form-item>
                <el-form-item>
                  <span class='uk-margin-small-left'>km/s</span>
                </el-form-item>
              </template>

              <template v-else-if="condition === 'greater'">
                <el-form-item prop='less'>
                  <el-input v-model='speed.less'></el-input>
                </el-form-item>
                <el-form-item>
                  <span class='uk-margin-small-left'>km/s</span>
                </el-form-item>
              </template>

              <template v-else-if="condition === 'less'">
                <el-form-item prop='greater'>
                  <el-input v-model='speed.greater'></el-input>
                </el-form-item>
                <el-form-item>
                  <span class='uk-margin-small-left'>km/s</span>
                </el-form-item>
              </template>
            </div>
          </el-form-item>
        </el-form>

        <el-button type='primary' style='width:100%' @click='search'>{{ $t('integration.search') }}</el-button>
      </div>
    </div>
    <!-- 详情模式 -->
    <div v-if="mode === 'detail'" style='width:100%;margin-left: 5px;margin-top: 5px;margin-right: 5px;'>
      <div style='background:#344962;color:white;height:30px;line-height: 30px;'
           class='w-100 uk-text-center cursor-pointer' @click='backSearch'>
                    <span>&lt;&lt;&nbsp;</span
                    >{{ $t('integration.return_to_search_criteria') }}
      </div>
      <div style='height:calc(100% - 50px);overflow-y: auto;padding: 10px 0'>
        <EquiInfo :detail-info='{carrier:detailInfo}' :extInfo='pointInfo'></EquiInfo>
      </div>
    </div>
  </div>
</template>
<script>
import EquiInfo from '@/pages/home/component/Map/component/equiInfo.vue'
import { mapTrackcarrierTrace } from '@/api/modules/map'
import { getLanguage } from '@/lang';

export default {
  props: {
    pointInfo: {},
    filterOptionList: {},
    detailInfo: {},
    tracableInfo: {},
    mapCom: {}
  },
  components: { EquiInfo },
  computed: {
    rules () {
      const dateValidator = (rules, value, callback) => {
        const from = this.traceSearchForm.from
        const to = this.traceSearchForm.to

        if (from && to && from instanceof Date && to instanceof Date) {
          if (from.getTime() > to.getTime()) return callback(new Error($t('integration.start_date_cannot_be_later_than_end_date')))
          return callback()
        }
        return callback()
      }
      const speedValidator = (rules, value, callback) => {
        const left = parseFloat(this.speed.less)
        const right = parseFloat(this.speed.greater)
        if (left && right) {
          if (left > right) {
            return callback(new Error($t('integration.the_left_section_cannot_be_greater_than_the_right_section')))
          }
          return callback()
        }
        return callback()
      }
      return {
        from: [{
          trigger: 'change',
          validator: dateValidator
        }],
        to: [{
          trigger: 'change',
          validator: dateValidator
        }],
        less: [{
          trigger: 'change',
          validator: speedValidator
        }],
        greater: [{
          trigger: 'change',
          validator: speedValidator
        }]
      }
    }
  },
  data () {
    return {
      condition: 'range',
      // 展示模式 condition-搜索条件模式 detail-轨迹点详细模式
      mode: 'condition',
      traceSearchForm: {
        from: null,
        to: null,
        option: 'filter_none'
      },
      // 速度过滤器
      speed: {
        greater: 120,
        less: 60
      },
      getLanguage
    }
  },
  watch: {
    tracableInfo: {
      immediate: true,
      handler () {
        console.log(this.tracableInfo.carrier.mode)
        this.traceSearchForm.from = null
        this.traceSearchForm.to = null
        // 上来先执行搜索 绘制轨迹
        this.search()
      }
    },
    // 速度筛选条件
    condition: {
      handler (newVal) {
        switch (newVal) {
          case 'range':
            this.speed = {
              less: 60,
              greater: 120
            }
            break
          case 'greater':
            this.speed = {
              less: 60,
              greater: undefined
            }
            break
          case 'less':
            this.speed = {
              less: undefined,
              greater: 120
            }
        }
      }
    }
  },
  methods: {
    search () {
      if (this.tracableInfo.carrier.lat === undefined) {
        return
      }
      mapTrackcarrierTrace({
        id: this.tracableInfo.carrier.id,
        startTime: new Date(this.traceSearchForm.from).getTime() || undefined,
        endTime: new Date(this.traceSearchForm.to).getTime() || undefined
      }).then(res => {
        if (!res.result.trace || !res.result.trace.length) {
          this.$message.warning($t('integration.no_track_found_e'))
        }
        // 按照过滤条件过滤点
        const trace = this.mapCom.filterTracePoint(res.result.trace, this.traceSearchForm.option, this.speed)
        this.mapCom.renderTrace(trace)
        this.traceSearchForm.from = res.result.from
        this.traceSearchForm.to = res.result.to
        this.$emit('update:detailInfo', null)

        this.backSearch()
      })
    },
    backSearch () {
      this.mode = 'condition'
    }
  }
}
</script>
